import { useEffect, useState } from 'react';
import {
  getReportsAttachmentsByUser,
  deleteAttachment,
} from '../../../api/reports.api';
import moment from 'moment-jalaali';
import { FileText, Trash2, Eye, Download } from 'lucide-react';

export default function AttachmentsTab({ userId }) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFiles();
  }, [userId]);

  const loadFiles = async () => {
    try {
      setLoading(true);
      const res = await getReportsAttachmentsByUser(userId);
      const attachments = res.data?.attachments || [];

      // ذخیره اطلاعات کامل شامل ID برای عملیات حذف
      const finalList = attachments.map((item) => ({
        id: item._id,
        url: item.fileUrl,
        date: item.createdAt,
        name: item.fileName || 'فایل ضمیمه',
      }));

      finalList.sort((a, b) => new Date(b.date) - new Date(a.date));
      setFiles(finalList);
    } catch (err) {
      console.error('Error loading attachments:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (fileId) => {
    if (
      !window.confirm(
        'آیا از حذف این فایل مطمئن هستید؟ این عمل غیرقابل بازگشت است.',
      )
    )
      return;

    try {
      await deleteAttachment(fileId);
      setFiles((prev) => prev.filter((f) => f.id !== fileId));
      alert('فایل با موفقیت حذف شد.');
    } catch (err) {
      console.error('Delete error:', err);
      alert('خطا در حذف فایل.');
    }
  };

  const isPDF = (url) =>
    url?.toLowerCase().endsWith('.pdf') || url?.includes('.pdf?');

  if (loading)
    return (
      <p className="text-center p-10 font-vazir text-gray-500">
        در حال بارگذاری فایل‌ها...
      </p>
    );
  if (files.length === 0)
    return (
      <p className="text-center p-10 text-gray-400 italic border-2 border-dashed rounded-2xl">
        هیچ فایل یا آزمایشی آپلود نشده است.
      </p>
    );

  return (
    <div className="font-vazir" dir="rtl">
      <h3 className="text-lg font-bold mb-6 text-gray-700 flex items-center gap-2">
        <span className="w-2 h-6 bg-blue-600 rounded-full"></span>
        آزمایشات و گزارش‌های بادی آنالیز
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {files.map((file) => (
          <div
            key={file.id}
            className="group relative bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-all">
            {/* بخش پیش‌نمایش */}
            <div className="relative h-48 bg-gray-50 flex items-center justify-center overflow-hidden">
              {isPDF(file.url) ? (
                <div className="flex flex-col items-center gap-2 text-red-500">
                  <FileText size={48} />
                  <span className="text-xs font-bold">PDF Document</span>
                </div>
              ) : (
                <img
                  src={file.url}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  alt=""
                />
              )}

              {/* لایه رویی در حالت هوور (Actions) */}
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
                <a
                  href={file.url}
                  target="_blank"
                  rel="noreferrer"
                  className="p-2 bg-white text-blue-600 rounded-full hover:bg-blue-600 hover:text-white transition-colors"
                  title="مشاهده">
                  <Eye size={18} />
                </a>
                <button
                  onClick={() => handleDelete(file.id)}
                  className="p-2 bg-white text-red-600 rounded-full hover:bg-red-600 hover:text-white transition-colors"
                  title="حذف">
                  <Trash2 size={18} />
                </button>
              </div>
            </div>

            {/* بخش توضیحات پایین کارت */}
            <div className="p-3 bg-white border-t">
              <div className="flex justify-between items-center mb-1">
                <span className="text-[10px] text-gray-400">
                  {moment(file.date).format('jYYYY/jMM/jDD')}
                </span>
                <span
                  className={`text-[9px] px-2 py-0.5 rounded-full ${isPDF(file.url) ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-600'}`}>
                  {isPDF(file.url) ? 'فایل PDF' : 'تصویر'}
                </span>
              </div>
              <p
                className="text-xs font-bold text-gray-700 truncate"
                title={file.name}>
                {file.name}
              </p>

              {/* دکمه دانلود مستقیم (مخصوصاً برای PDF) */}
              <a
                href={file.url}
                download
                className="mt-2 flex items-center justify-center gap-1 w-full py-1.5 bg-gray-50 text-[10px] text-gray-500 rounded-lg hover:bg-gray-100 transition">
                <Download size={12} />
                دانلود فایل
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
